<template>
  <div class="d-flex align-center justify-center">
    <v-btn
      :color="course.active ? 'error' : 'success'"
      :loading="loading"
      small
      outlined
      @click="toggleStatus"
    >
      <v-icon left small>
        {{ course.active ? 'mdi-pause' : 'mdi-play' }}
      </v-icon>
      {{ course.active ? $t('courses.deactivate') : $t('courses.activate') }}
    </v-btn>

    <v-dialog v-model="showConfirmDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">
          {{ course.active ? $t('courses.confirmDeactivate') : $t('courses.confirmActivate') }}
                </v-card-title>

        <v-card-text>
          <p>
            <strong>{{ $t('courses.courseName') }}:</strong> {{ course.name }}
          </p>
          <p>
            <strong>{{ $t('courses.grade') }}:</strong>
            {{ getGradeName() }}
          </p>
                    <p>
            <strong>{{ $t('courses.section') }}:</strong> {{ getSectionName(course.section) }}
          </p>
          <div class="d-flex align-center">
            <strong>{{ $t('courses.studentCount') }}:</strong>
            <v-chip
              :color="getStudentCountColor(course.studentCount)"
              text-color="white"
              small
              class="ml-2"
              min-width="60px"
            >
              {{ course.studentCount || 0 }}
            </v-chip>
          </div>

          <div v-if="course.active && hasActiveStudents" class="mt-4">
            <v-alert type="error" outlined>
              {{ $t('courses.hasActiveStudentsWarning') }}
            </v-alert>
          </div>
                </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="showConfirmDialog = false"
          >
            {{ $t('general.cancel') }}
          </v-btn>
          <v-btn
            :color="course.active ? 'error' : 'success'"
            :loading="loading"
            @click="confirmToggle"
          >
            {{ course.active ? $t('courses.deactivate') : $t('courses.activate') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import courseService from '@/services/course.service';

export default {
  name: 'CourseStatusToggle',
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    showConfirmDialog: false,
    hasActiveStudents: false,
  }),
  methods: {
    toggleStatus() {
      this.showConfirmDialog = true;
    },
    async confirmToggle() {
      this.loading = true;
      try {
        if (this.course.active) {
          await this.deactivateCourse();
        } else {
          await this.activateCourse();
        }

        this.showConfirmDialog = false;
        this.$emit('status-changed', this.course, !this.course.active);
      } catch (error) {
        this.$toast.error(
          this.course.active
            ? this.$t('courses.errorDeactivating')
            : this.$t('courses.errorActivating'),
        );
      } finally {
        this.loading = false;
      }
    },
    async deactivateCourse() {
      const { status } = await courseService.deactivateCourse(this.course.id);
      if (status !== 200) {
        throw new Error('Failed to deactivate course');
      }
    },
    async activateCourse() {
      const { status } = await courseService.activateCourse(this.course.id);
      if (status !== 200) {
        throw new Error('Failed to activate course');
      }
    },
    getGradeName() {
      // Extraer el nombre del grado desde course.name
      // Formato esperado: "2° Segundo-A" -> extraer "2° Segundo"
      if (this.course.name) {
        const parts = this.course.name.split('-');
        if (parts.length > 1) {
          return parts[0].trim();
        }
      }
      // Fallback al método anterior
      return this.course.grade_desc && this.course.grade_desc.name
        ? this.course.grade_desc.name
        : (`Grado ${this.course.grade}`);
    },
    getSectionName(section) {
      // Convertir número de sección a letra (0=A, 1=B, 2=C, etc.)
      const sectionLetter = String.fromCharCode(65 + section); // 65 = código ASCII para 'A'
      return `Sección ${sectionLetter}`;
    },
    getStudentCountColor(count) {
      if (!count || count === 0) return 'grey';
      return 'green';
    },
  },
};
</script>

<style scoped>
.v-chip {
  font-weight: 500;
}

.v-btn {
  text-transform: none;
}
</style>
